import { render, staticRenderFns } from "./mallItem.vue?vue&type=template&id=77fc58c3&scoped=true&"
import script from "./mallItem.vue?vue&type=script&lang=js&"
export * from "./mallItem.vue?vue&type=script&lang=js&"
import style0 from "./mallItem.vue?vue&type=style&index=0&id=77fc58c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc58c3",
  null
  
)

export default component.exports